import {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {ChevronDown, Forward} from 'lucide-react';
import {cn, useModalControls} from '@chekin/guestapp-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import ShareRegistrationLink from 'components/ModalSheets/ShareRegistrationLink';

type ModalTitleProps = {
  currentTotalGuest: number;
  totalGuest: number;
  onGuestCountClick: () => void;
};

const ModalTitle = memo(
  ({currentTotalGuest, totalGuest, onGuestCountClick}: ModalTitleProps) => {
    const {t} = useTranslation();
    const {isOpen, closeModal, openModal} = useModalControls();

    return (
      <>
        <div
          className={cn(
            'w-full flex items-center space-x-2 justify-between ',
            'absolute -top-6 left-0  bg-[var(--primary-10)] p-6',
            'md:static md:bg-transparent md:py-4 md:px-0',
          )}
        >
          <button
            onClick={onGuestCountClick}
            className="min-w-fit flex items-center gap-1 bg-transparent border-none p-0 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <p className="font-semibold text-base text-[var(--button-primary-background)] lowercase">
              {currentTotalGuest} {t('of')} {totalGuest} {t('guests')}
            </p>
            <ChevronDown
              className="w-4 h-4 flex-shrink-0"
              style={{color: 'var(--button-primary-background)'}}
              strokeWidth={2}
            />
          </button>

          <div className="w-full h-[1.5px] bg-[var(--button-primary-background)]" />

          <button
            onClick={openModal}
            className="flex items-center gap-2 bg-transparent border-none p-0 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <Forward
              className="w-5 h-5 flex-shrink-0"
              style={{color: 'var(--button-primary-background)'}}
              strokeWidth={2}
            />
            <p className="font-semibold text-base text-[var(--button-primary-background)]">
              {t('share')}
            </p>
          </button>
        </div>
        <div className="md:hidden h-10 w-full"></div>

        <ModalSheet
          isOpenModalSheet={isOpen}
          handleCloseModal={closeModal}
          withCloseButton
          maxWidth={'375px'}
        >
          <ShareRegistrationLink />
        </ModalSheet>
      </>
    );
  },
);

ModalTitle.displayName = 'ModalTitle';

export {ModalTitle};
